// Rangaire — highlight the active nav item based on current URL
(function () {
  var rawPath = window.location.pathname;
  var path = rawPath.replace(/\/$/, '') || '/';

  document.querySelectorAll('.m-menu__link--main').forEach(function (link) {
    var rawHref = (link.getAttribute('href') || '').replace(/\/$/, '') || '/';

    var isActive = false;

    if (rawHref === '/') {
      // Home link: only active on the exact homepage
      isActive = (path === '/' || path === '');
    } else {
      // All other links: exact match or sub-path
      isActive = (path === rawHref || path.startsWith(rawHref + '/'));
    }

    if (isActive) link.classList.add('rng-nav-active');
  });
})();
